import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

var state = {
  userId: '', // 登录人ID
  logininfo: {}, // 登录人信息
  currentmenu: [], // 当前菜单
  menudefault: '0', // 选中菜单
  currentuser: {}, // 当前用户
  breadcrumb: [],
  hospitalNatureData: [], // 医院等级
  hospitalLevelData: [], // 医院类型
  orgTypeData: [], // 机构类型
  currentoperdata: {}, // 当前操作数据
  completednot: true, // 当前操作是否完成
  control: {
    qtareAddition: false, // 问卷添加/修改控制
    doctorAddition: false, // 医生添加/修改控制
    popularAddition: false, // 科普添加/修改控制
    propagandaAddition: false, // 宣教添加/修改控制
    noticeAddition: false, // 通知添加/修改控制
  },
  currentlocation: [{
    name: '问卷管理', // 
    type: '1',
    url: 'updateQtareAddition',
    manage: '',
  }],
  insertsequencenumber: 0,
  insertquestion: [],
  selectsuperiorquestion: {},
}
var mutations = {
  updateuserId (state, data) {
    state.userId = data
  },
  // 更新登录人信息
  updatelogininfo (state, data) {
    state.logininfo = data
  },
  // 更新当前菜单数据
  currentmenu (state, data) {
    state.currentmenu = data
  },
  // 更新选中的菜单
  updatemenudefault (state, data) {
    state.menudefault = data
  },
  // 更新当前用户数据
  currentuser (state, data) {
    state.currentuser = data
  },
  // 更新当前位置
  updateCurrentlocation (state, data) {
    state.currentlocation = data
  },
  // 更新控制信息
  updateControl (state, data) {
    state.control = data
  },
  // 更新问卷添加/修改控制信息
  updateQtareAddition (state, data) {
    state.control.qtareAddition = data
  },
  // 更新科普添加/修改控制信息
  updatePopularAddition (state, data) {
    state.control.popularAddition = data
  },
  // 更新宣教添加/修改控制信息
  updatePropagandaAddition (state, data) {
    state.control.propagandaAddition = data
  },
  // 更新通知添加/修改控制信息
  updateNoticeAddition (state, data) {
    state.control.noticeAddition = data
  },
  // 更新医生添加/修改控制信息
  updateDoctorAddition (state, data) {
    state.control.doctorAddition = data
  },
  // 更新医院等级
  updatehospitalNatureData (state, data) {
    state.hospitalNatureData = data
  },
  // 更新医院类型
  updatehospitalLevelData (state, data) {
    state.hospitalLevelData = data
  },
  // 更新机构类型
  updateorgTypeData (state, data) {
    state.orgTypeData = data
  },
  // 更新当前操作数据
  updatecurrentoperdata (state, data) {
    state.currentoperdata = data
  },
  // 更新当前操作数据
  updatecompletednot (state, data) {
    state.completednot = data
  },
  SelectSuperiorQuestion (state, data) {
    state.selectsuperiorquestion = data
  },
  InsertQuestion (state, data) {
    state.insertquestion = data
  },
  InsertseQuenceNumber (state, data) {
    state.insertsequencenumber = data
  },
}
var action = {
}
const store = new Vuex.Store({
  state,
  mutations,
  action,
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]
})

export default store